import CustomButton from 'components/CustomInput/Button';
import { useState,useEffect } from 'react';
import { useSelector } from 'react-redux';
const usePanelSearchMember = () => {
    const [selectedMember, setSelectedMember] = useState([]);
    const [isDisabledAll, setIsDisabledAll] = useState(false)
    const { reviewPanelMemberList } = useSelector((state) => state.reviewPanel);
    const checkedAll = () => {
        let newReviewPanelMemberList = reviewPanelMemberList?.data.reduce((group, curP) => {
            if(!selectedMember.find((item)=>item.id===curP.id)){
                return group.concat(curP)
            }
            return group
        }, [])
        setSelectedMember([...selectedMember,...newReviewPanelMemberList])
    }
    useEffect(()=>{
        if(!reviewPanelMemberList) return setIsDisabledAll(false)
        setIsDisabledAll(true)
        reviewPanelMemberList?.data.forEach((item)=>{
            if(!selectedMember.find(ele=>ele.id===item.id)){
                setIsDisabledAll(false)
                return
            }
        })
    },[selectedMember,reviewPanelMemberList])
    const gender = (type) =>{
        let gender = type||'-'
        switch (type) {
            case 'M':
                gender='Male'
                break;
            case 'F':
                gender='Female'
                break;
            default:
                break;
        }
        return gender
    }
    const columns = [
        {
            field: 'action',
            headerName: (
                <div>
                    <CustomButton onClick={checkedAll} disabled={isDisabledAll}>Add All</CustomButton>
                </div>
            ),
            disableItemSort: true,
            valueGetter: (params) => {
                const isExist = selectedMember.some((item) => {
                    return item.email === params.row.email;
                });
                return (
                    <CustomButton
                        disabled={isExist}
                        onClick={() => {
                            if (!isExist) {
                                setSelectedMember([...selectedMember, params.row]);
                            }
                        }}
                    >
                        Add
                    </CustomButton>
                );
            },
        },
        { field: 'email', headerName: 'Email', width: 200 },
        { field: 'title', headerName: 'Title', width: 100 },
        { field: 'surname', headerName: 'Surname', width: 140 },
        {
            field: 'firstName',
            headerName: 'First Name',
            width: 140,
        },
        { field: 'gender', headerName: 'Gender', width: 100, valueGetter: (params) => gender(params.value) },
        { field: 'department', headerName: 'Department', width: 140 },
        { field: 'post', headerName: 'Post', width: 100 },
    ];

    return { rows: reviewPanelMemberList?.data || [], columns, selectedMember, setSelectedMember };
};

export default usePanelSearchMember;
